/* The shop.
 *
 * Products are archived here the same way projects are: a page on this site,
 * in this site's format. Stripe only handles the money — you make a product
 * in the Stripe dashboard, click "Buy button", and paste the two values it
 * gives you into `buyButtonId` and the publishable key below.
 *
 * Until an item has a buyButtonId it still shows as a page, just with no
 * button on it, so you can put the work up before the till is ready.
 *
 * Stock: set it in Stripe, not here. On the payment link choose "Limit the
 * number of payments" and it deactivates itself when they're gone. Set
 * `soldOut: true` here as well if you want the page to say so.
 */

/* From Stripe: Developers > API keys > Publishable key. It starts pk_live_
   and is safe in public code — it can only start a checkout, never read
   anything from the account. */
export const STRIPE_PUBLISHABLE_KEY = '';

const PRODUCTS = [
  {
    slug: 'thingdoms-shirt',
    title: 'Thingdoms Shirt',
    subtitle: 'Screen printed, small run',
    overview: [
      'Placeholder. Images borrowed from the Thingdoms project so the shop has something to look at while the real products are photographed.',
      'Written the way a project is: what it is, how it was made, how many exist.',
    ],
    details: [
      ['Material', '100% cotton'],
      ['Sizes', 'S, M, L, XL'],
      ['Edition', 'Run of 10'],
      ['Ships from', 'Edinburgh'],
    ],
    price: '\u00a335',
    hero: '01-front.png',
    media: ['02-back.png', '03-detail.png'],
    buyButtonId: '',
    soldOut: false,
  },
  {
    slug: 'sticker-cards',
    title: 'Collectible Cards',
    subtitle: 'Printed set',
    overview: [
      'Placeholder. Images borrowed from the Sticker Book project.',
      'A set of cards, printed and hand collated.',
    ],
    details: [
      ['Format', 'Card set'],
      ['Finish', 'Matte'],
      ['Edition', 'Run of 10'],
      ['Ships from', 'Edinburgh'],
    ],
    price: '\u00a320',
    hero: '01-pack.png',
    media: ['02-rare.png', '03-moment.png'],
    buyButtonId: '',
    soldOut: false,
  },
  {
    slug: 'letters-print',
    title: 'Letters Print',
    subtitle: 'Giclee, signed',
    overview: [
      'Placeholder. Images borrowed from the Letters project.',
      'The wordmark, printed from the found letterform archive.',
    ],
    details: [
      ['Format', 'Giclee print'],
      ['Size', 'A2'],
      ['Edition', 'Run of 10, signed'],
      ['Ships from', 'Edinburgh'],
    ],
    price: '\u00a340',
    hero: '02-sheet.png',
    media: ['01-print.png', '03-detail.png'],
    buyButtonId: '',
    soldOut: false,
  },
];

export default PRODUCTS;

export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);

const enc = (s) => s.split('/').map(encodeURIComponent).join('/');

export const productImageUrl = (product, file) =>
  `shop/${enc(product.slug)}/${enc(file)}`;

export const getProductHero = (product) =>
  product && product.hero ? productImageUrl(product, product.hero) : '';

/* Whether the till is switched on at all. */
export const shopIsLive = () =>
  Boolean(STRIPE_PUBLISHABLE_KEY) && PRODUCTS.some((p) => p.buyButtonId);
